import { Grid } from "@mui/material"
import { FileRejection, useDropzone } from "react-dropzone"
import { SurveyRecordPhoto, UpdateSurveyRecordPhoto } from "../../generated/graphql"
import config from "../../services/config"
import { parsePhotoFormatsEnv } from "../../services/utils"
import GalleryImage from "../GalleryImage/GalleryImage"
import styles from './Gallery.module.scss'

export interface GalleryProps {
    images: any
    onDrop: (accepptedFiles: File[], refejectFiles: FileRejection[]) => void
    onDelete: (image: any) => void
    onUpdate: (id: string, update: UpdateSurveyRecordPhoto) => void
    onDownload: (image: any) => void
    disableAdd?: boolean
    disableDelete?: boolean
    disableDownload?: boolean
    disableUpdate?: boolean
}

export default function Gallery(props: GalleryProps) {
    const { images, onDrop, onDelete, onDownload, onUpdate, disableDelete = false, disableDownload = false, disableAdd = false, disableUpdate = false } = props
    const acceptFormats = parsePhotoFormatsEnv(config.ALLOWED_PHOTO_FORMATS)
    const { getRootProps, isDragActive, getInputProps } = useDropzone({
        onDrop, disabled: disableAdd,
        accept: {
            'image/*': acceptFormats
        }
    })

    return (
        <Grid container className={styles.Gallery}>
            {images?.map((image: SurveyRecordPhoto) => <GalleryImage
                image={image}
                key={image?.id}
                onDelete={onDelete}
                onDownload={onDownload}
                onUpdate={onUpdate}
                disableDelete={disableDelete}
                disableDownload={disableDownload}
                disableUpdate={disableUpdate}
            />)}
            {!disableAdd && <GalleryImage key="add" onUpdate={onUpdate} isDragActive={isDragActive} getRootProps={getRootProps} getInputProps={getInputProps} />}
        </Grid>
    )
}
